import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaArrowRight, FaDownload } from 'react-icons/fa';
import { SplitText, FadeInText } from './AnimatedText';
import ParticleBackground from './ParticleBackground';
import MagneticButton from './MagneticButton';
import AuroraBackground from './AuroraBackground';
import portfolioData from '../data/portfolio.json';
import './Home.css';

const Home = () => {
    const profile = portfolioData.profile;

    return (
        <div className="home">
            {/* Hero Section */}
            <section className="hero">
                <AuroraBackground />
                <ParticleBackground particleCount={40} />
                <div className="container">
                    <div className="hero-content">
                        <motion.div
                            className="hero-image"
                            initial={{ opacity: 0, y: -30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                        >
                            <div className="avatar-placeholder">
                                <img 
                                    src="/pfp.jpg" 
                                    alt="Vasudev Kishor" 
                                    className="avatar-image"
                                />
                            </div>
                        </motion.div>

                        <motion.div
                            className="hero-text"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                        >
                            <h1 className="hero-title">
                                <SplitText delay={0.2}>Hi, I'm Vasudev Kishor</SplitText>
                            </h1>
                            <h2 className="hero-subtitle">
                                <FadeInText delay={0.4}>{profile?.title || 'Full Stack & AI Developer'}</FadeInText>
                            </h2>
                            <p className="hero-description">
                                <FadeInText delay={0.6}>
                                    {profile?.bio || 'Passionate developer creating beautiful and functional web applications with integrating AI.'}
                                </FadeInText>
                            </p>

                            <div className="hero-buttons">
                                <MagneticButton
                                    href="/Vasudev Kishor Resume .pdf"
                                    download="Vasudev_Kishor_Resume.pdf"
                                    className="btn btn-secondary"
                                >
                                    <FaDownload /> CV
                                </MagneticButton>
                            </div>

                            <div className="social-links">
                                {profile?.social_links && (
                                    <>
                                        <motion.a
                                            href={profile.social_links.github}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            whileHover={{ scale: 1.15, y: -3 }}
                                            whileTap={{ scale: 0.95 }}
                                            transition={{ duration: 0.2 }}
                                            className="social-link"
                                        >
                                            <FaGithub />
                                        </motion.a>
                                        <motion.a
                                            href={profile.social_links.linkedin}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            whileHover={{ scale: 1.15, y: -3 }}
                                            whileTap={{ scale: 0.95 }}
                                            transition={{ duration: 0.2 }}
                                            className="social-link"
                                        >
                                            <FaLinkedin />
                                        </motion.a>
                                    </>
                                )}
                            </div>
                        </motion.div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="container">
                    <motion.div
                        className="cta-content"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                    >
                        <h2>
                            <SplitText delay={0.2}>Let's Work Together</SplitText>
                        </h2>
                        <p>
                            <FadeInText delay={0.4}>I'm always interested in new opportunities and exciting projects.</FadeInText>
                        </p>
                        <MagneticButton
                            component={Link}
                            to="/contact"
                            className="btn btn-primary"
                        >
                            Get In Touch <FaArrowRight />
                        </MagneticButton>
                    </motion.div>
                </div>
            </section>
        </div>
    );
};

export default Home; 